import { compose } from '@reduxjs/toolkit';
import { ComponentType } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { currentUserReducerName } from 'store/current-user/reducer';
import { RootState } from 'store/rootReducer';

import CopyrightNotice from 'components/common/atoms/CopyrightNotice/CopyrightNotice.layout';


const mapStateToProps = (state: RootState) => ({ accessTokenExpirationTimeStamp: state[currentUserReducerName].accessTokenExpirationTimeStamp });

const decorate = compose<ComponentType<{ namespace?:string }>>(
    withTranslation('common'),
    connect(mapStateToProps),
);

export default decorate(CopyrightNotice);

